<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_People_User_Person-_Groud"
      data-name="Icon/People User Person- Groud"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="12.938"
      viewBox="0 0 14.376 12.938"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_People"
        data-name="Icon/Icon/People"
        d="M9.345,12.938a.72.72,0,0,1-.719-.719,3.594,3.594,0,0,0-7.188,0,.719.719,0,1,1-1.437,0,5.029,5.029,0,0,1,8.582-3.56A3.593,3.593,0,0,1,14.376,11.5a.719.719,0,0,1-1.437,0,2.152,2.152,0,0,0-3.49-1.69,5.042,5.042,0,0,1,.615,2.408A.719.719,0,0,1,9.345,12.938Zm1.437-5.75a2.156,2.156,0,1,1,2.156-2.156A2.159,2.159,0,0,1,10.782,7.188Zm0-2.876a.719.719,0,1,0,.719.719A.72.72,0,0,0,10.782,4.313ZM5.032,5.75A2.875,2.875,0,1,1,7.906,2.876,2.878,2.878,0,0,1,5.032,5.75Zm0-4.313A1.438,1.438,0,1,0,6.469,2.876,1.44,1.44,0,0,0,5.032,1.437Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class UsersIcon extends Vue {}
</script>

<style>
</style>
